import { CSSTransitionGroup } from 'react-transition-group';


const Loader = (props) => {
    return (
        <CSSTransitionGroup
            transitionName="fade-in"
            transitionAppear={true}
            transitionAppearTimeout={500}
            transitionEnter={false}
            transitionLeave={true}
            transitionLeaveTimeout={300}>
            <div id="loading">
                <div className="loading-container">
                    <p className="loading-text">{props.message}</p>
                </div>
            </div>
        </CSSTransitionGroup>
    )
}

export default Loader;